import BaseService from './base.service';

export default class WorkflowService extends BaseService {
  getWorkflowList(companyUuid) {
    return this.get(`workflow/list/${companyUuid}`);
  }

  getWorkflows(workflowUuid) {
    return this.get(`workflow/view/${workflowUuid}`);
  }

  setDefaultWorkflow(companyUuid, data) {
    return this.create(`workflow/setDefault/${companyUuid}`, data);
  }

  deleteWorkflow(uuid) {
    return this.delete(`workflow/delete/${uuid}`);
  }

  editWorkflow(uuid) {
    return this.get(`workflow/edit/${uuid}`);
  }

  saveWorkflow(companyUuid, data) {
    return this.create(`workflow/save/${companyUuid}`, data);
  }

  getAdminWorkflow(uuid = '') {
    return this.get(`admin/workflow/${uuid}`);
  }

  saveAdminWorkflow(data) {
    return this.create('admin/workflow', data);
  }
}
